import { render, staticRenderFns } from "./cell-status.vue?vue&type=template&id=0c2a0fa7&scoped=true"
import script from "./cell-status.vue?vue&type=script&lang=js"
export * from "./cell-status.vue?vue&type=script&lang=js"
import style0 from "./cell-status.vue?vue&type=style&index=0&id=0c2a0fa7&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2a0fa7",
  null
  
)

export default component.exports